
































import config from '@/config/index';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import MantenedorGridSinCodigo from "@/reusable/Grid/MantenedorGridSinCodigo.vue";

@Component({
  name: 'Integration List',
  components: {
  },
})
export default class IntegrationLists extends Vue {
  @Prop({ default: [] }) IntegrationList!: any;


}
